<template>
	<section class='knd-map'>

		<div class='knd-map__content knd-container'>
			<div class='knd-gemeente knd-input-field m-b-md'>
				<div class='input-label'>Zoek op gemeente</div>
				<input id="myinput" placeholder="Gemeente" />
			</div>

			<div class='knd-map__legend'>
				<ul class='knd-map__legend-list'>
					<li v-for="(item, propertyName) in statusLabel" :key="propertyName" class="knd-map__legend-item">
						<span :class="'knd-legend__item-block knd-' + propertyName"></span>
						<span class="knd-legend__item-label">{{item}}</span>
					</li>
				</ul>
			</div>
			<div class='container-map' ref='chart'>
				<div class='knd-tooltip' ref='tooltip' v-if="highlight" 
					v-bind:style="{ 'left': tooltipXpos +'px', 'top': tooltipYpos +'px'}">
					<div class='knd-tooltip__title'>
						{{highlight.GM_NAAM}}
					</div>

					<div class='knd-tooltip__status'>
							{{statusLabel[highlight.Status]}}
					</div>

<!-- 					<div 
						class='knd-tooltip__info knd_tooltip__zoomin_label ta-center'
						v-if="highlight.Status === 'geen-onderzoek'"
						>
						Stuur een brief om je gemeente aan te sporen
					</div> -->
				</div>
			</div>


		</div>			
	</section>
</template>

<script>

	import gemeenteData from '@/assets/geo/gemeente_2023.json';

	import * as Awesomplete from 'awesomplete';
	import 'awesomplete/awesomplete.css';

	import * as topojson from 'topojson';
	
	import MapChart from './map';
	import './kaart.scss';
	import './tooltip.scss';

	const statusLabel = {
		onderzoek: 'Lopend onderzoek',
		afgerond: 'Onderzoek afgerond',
		'geen-onderzoek': 'Geen onderzoek',
		afwezig:  'Staat niet in de Vastgoedboeken'
	}

	const vueObject = {
		data: function() {
			return {
				highlight: undefined,
				statusLabel: statusLabel

			}
		},
		mounted: function() {
			// this.renderTooltip();

			this.geoData = topojson.feature(gemeenteData, gemeenteData.objects.gemeente_2023);

			this.renderChart();
			this.renderAutoComplete();
		},
		methods: {
			renderAutoComplete() {
				this.inputGemeente = document.getElementById("myinput");

				let gemeentes =  this.geoData.features.map(d => { 
					return {label: d.properties.GM_NAAM, value: d.properties.GM_CODE}
				});

				new Awesomplete(this.inputGemeente, {
					list: gemeentes,
					replace: (suggestion) => {
						this.inputGemeente.value = suggestion.label;
						this.highlightMap(suggestion.value);
					}					
				});
			},

			highlightMap(code) {
				this.chart.setItemActive(`.knd-${code}`);
			},

			renderChart() {
				let arr1 = this.geoData.features;
				let arr2 = this.$store.state.mapStatus;

				for(let i=0; i<arr1.length; i++) {
					let data = arr2.find((itmInner) => itmInner.GemeentecodeGM === arr1[i].properties.GM_CODE);

					arr1[i].properties = {
					...arr1[i].properties, 
					...(arr2.find((itmInner) => itmInner.GemeentecodeGM === arr1[i].properties.GM_CODE))}
					}

				this.chart = new MapChart()
					.container(this.$refs.chart)
					.data(this.geoData)
					.margin({top: 10, right: 30, bottom: 30, left: 30})
					.classNames(d => `knd-${d.properties.GM_CODE} knd-${d.properties.Status}`)
					.height(true)
					.width(true)
					.onMouseOver((d, pos) => this.showTooltip(d, pos))
					// .onMouseOut(d => this.tooltip.hide())
					.render();
			},

			showTooltip(d, pos) {
				this.highlight = d;
				this.pos = pos;

				if(!this.$refs.tooltip) return;

				this.$refs.tooltip.classList.add('show');

				let padding = 15;
				let tooltipWidth = this.$refs.tooltip ? this.$refs.tooltip.offsetWidth : 0

				this.tooltipYpos = pos.mouseY + padding;
				this.tooltipXpos = pos.mouseX - (tooltipWidth /2);
			}
		}
	}

	export default vueObject;
</script>


<!-- 
	gemeentekaart van https://www.cbs.nl/nl-nl/dossier/nederland-regionaal/geografische-data/wijk-en-buurtkaart-2020
	gemeentecodes > https://www.cbs.nl/nl-nl/onze-diensten/methoden/classificaties/overig/gemeentelijke-indelingen-per-jaar/indeling%20per%20jaar/gemeentelijke-indeling-op-1-januari-2020
	mapshaper.org
	filter 'WATER != "JA"'
	Simplify 1%
	-proj wgs84
	export to topojson
 -->